<!-- Application Number -->

<span
  *ngIf="mode === 'applicationNumber'"
  class="activity-link clickable"
  (click)="onApplicationClick($event)"
>
  {{ row.applicationNumber }}
</span>


<!-- Current Activity -->

<div
  *ngIf="mode === 'currentActivity'"
  class="activity-container"
  (click)="$event.stopPropagation()"
>

  <!-- SINGLE ACTIVITY -->
  <span
    *ngIf="activities.length === 1"
    #activityTooltip="matTooltip"
  class="activity-link single-activity"
    [class.clickable]="!!activityNames"
    [class.activity-disabled]="!activityNames"
    matTooltip=""
    matTooltipTouchGestures="off"
    matTooltipPosition="above"
    matTooltipClass="custom-tooltip-style"
    (mouseenter)="updateOverflowTooltip($event, activityTooltip)"
    (focusin)="updateOverflowTooltip($event, activityTooltip)"
    (mouseleave)="hideOverflowTooltip(activityTooltip)"
    (focusout)="hideOverflowTooltip(activityTooltip)"
  (click)="onActivityClick(activity, $event)"
  >
    {{ activityNames }}
  </span>


  <!-- MULTIPLE ACTIVITIES -->
  <span
    *ngIf="activities.length > 1"
  class="activity-link multiple-activities clickable"
    (mouseenter)="openActivitiesDropdown($event)"
    (mouseleave)="closeActivitiesDropdown()"
  >
    {{ activityNames }}
  </span>

</div>


<!-- MULTIPLE ACTIVITIES DROPDOWN -->

<ng-template #activityDropdown>

  <div
    class="activities-dropdown"
    (mouseenter)="keepDropdownOpen()"
    (mouseleave)="closeActivitiesDropdown()"
    (click)="onDropdownClick($event)"
  >

    <div
      *ngFor="let activity of activities"
      class="activity-item"
  [class.selected]="
    selectedActivityDataId === activity.activityDataId
  "
      (click)="onActivityClick(activity, $event)"
    >
      {{ activity.activityName }}
    </div>

  </div>

</ng-template>